import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { MenuItemDto } from '../../../../services/menu/dto/api-response-dto';
import { CurrencyPipe } from '../../../../pipes/currency.pipe';
import { ConfigService } from '../../../../services/config.service';
@Component({
  selector: 'app-product-list-item',
  imports: [CommonModule, CurrencyPipe],
  templateUrl: './product-list-item.component.html',
  styleUrl: './product-list-item.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ProductListItemComponent {
  @Input() productItem!: MenuItemDto;
  @Output() itemClick = new EventEmitter<MenuItemDto>();

  constructor(private configService: ConfigService) {
  }

  ngOnInit(): void {
    this.productItem.min_value = this.getMinPriceComplements(this.productItem) + (this.productItem.price || 0);
    this.productItem.min_value_promotional = this.getMinPriceComplements(this.productItem) + (this.productItem.promotional_price || 0);
  }

  get hasMinValue(): boolean {
    return this.productItem.min_value > (this.productItem.price || 0) || this.productItem.min_value_promotional > (this.productItem.promotional_price || 0);
  }

  get displayPrice(): number {
    if (this.productItem.promotional_price && this.productItem.min_value_promotional > this.productItem.promotional_price) {
      return this.productItem.min_value_promotional;
    }
    if (this.productItem.promotional_price) {
      return this.productItem.promotional_price;
    }
    if (this.productItem.min_value > this.productItem.price) {
      return this.productItem.min_value;
    }
    return this.productItem.price;
  }

  get originalDisplayPrice(): number {
    if (this.productItem.min_value > 0) {
      return this.productItem.min_value;
    }
    return this.productItem.price;
  }

  getMinPriceComplements(item: MenuItemDto): number {
    let totalMinPrice = 0;

    const mandatoryChoices = item.choices?.filter(
      (choice) => choice.required === 1,
    );

    if (!mandatoryChoices?.length) {
      return 0;
    }

    for (const choice of mandatoryChoices) {
      if (!choice.options.length) continue;

      const sortedOptions = choice.options.sort((a, b) => a.price - b.price);

      const minSelections = choice.min ?? 1;

      const minPrice = (sortedOptions[0]?.price || 0) * minSelections;

      totalMinPrice += minPrice;
    }
    return totalMinPrice;
  }

  get isLandscapeMode(): boolean {
    return this.configService.isLandscapeTabletEnabled();
  }
  onItemClick(): void {
    this.itemClick.emit(this.productItem);
  }
}
